import { computed, makeObservable } from 'mobx';
import { AnyClockwork } from './RuntimeClock';

export class TickingClock {
  readonly tickingClock: AnyClockwork;

  constructor(tickingClock) {
    makeObservable(this);
    this.tickingClock = tickingClock;
  }

  get tickingTime(): number {
    return this.tickingClock.tickingTime;
  }

  @computed
  get tickingDate(): Date {
    return new Date(this.tickingTime);
  }
}
